// Team members

const team = [
  {
    id: 1,
    name: "Simon Featherstone",
    role: "Chairman",
    image: "/assets/images/simon-realesrgan-x4plus.jpg",
    bio: "Our global markets expert, Simon’s career history includes MD of Business Finance at Shawbrook; Global CEO of Bibby Financial Services; and MD at Lloyds TSB Commercial Finance the UK leader in Invoice Finance."
  },
  {
    id: 2,
    name: "Sanjay Padhee",
    role: "CEO and Co-Founder",
    image: "/assets/images/sanjay-realesrgan-x4plus.jpg",
    bio: "Sanjay boasts 24-years’ technology leadership in a mix of SMEs and FTSE 100 organisations (Carphone Warehouse, Elsevier). Creator of SPIDER® algorithms & framework and researcher on blockchain protocols and invoice finance."
  },
  {
    id: 3,
    name: "Ricky Shankar",
    role: "Co-Founder",
    image: "/assets/images/ricky-realesrgan-x4plus.jpg",
    bio: "Formerly CEO of a number of software businesses in the UK & USA. 23-years tech experience in London, Paris, Chicago and Mumbai."
  },
  {
    id: 4,
    name: "Paul Tindall",
    role: "Head of Credit Risk",
    image: "/assets/images/paul-realesrgan-x4plus.jpg",
    bio: "Paul is our invoice finance risk and operations expert. A 40+year career in commercial and corporate banking, the second half in invoice and asset finance. Previous involvement with the launch of another fintech."
  },
  {
    id: 5,
    name: "Alan Bernard",
    role: "Non Executive Director & Vice Chairman",
    image: "/assets/images/alan-realesrgan-x4plus.jpg",
    bio: "Alan has had 20+ years as a Business & IT leader at M&S and then responsible for launching Selfridges’ first digital platform. Alan brings his debtor relations and supply chain expertise"
  },
  {
    id: 6,
    name: "Peter Presland",
    role: "Non-Executive Director",
    image: "/assets/images/peter-realesrgan-x4plus.jpg",
    bio: "Peter was formerly Executive Chairman of Rebus Group Plc; CEO of C. E. Heath & Co.; Chairman of LINK Interchange Network Ltd; and Chairman of VocaLink Ltd."
  },
  {
    id: 7,
    name: "Tracy Fletcher",
    role: "Non-Executive Director",
    image: "/assets/images/tracy-realesrgan-x4plus.jpg",
    bio: "Tracy is the Founder & Director of Campbell & Fletcher Ltd. Tracy has been an entrepreneur for 15 years. She has over 20 years of experience in banking, having worked at senior levels for HSBC with particular expertise in leading large retail teams, relationship management and operational risk."
  },
  {
    id: 8,
    name: "Tim Everest",
    role: "Non-Executive Director",
    image: "/assets/images/tim-realesrgan-x4plus.jpg",
    bio: "An expert in payments market infrastructure and risk, having held roles inc. CEO Cheque & Credit Clearing Co, COO Bank of England CHAPS, CTO & CSO Pay.UK and COO CHAPS Ltd."
  },
  {
    id: 9,
    name: "Neeraj Bhatia",
    role: "Non-Executive Director",
    image: "/assets/images/neeraj-realesrgan-x4plus.jpg",
    bio: "Neeraj is the Group CEO & Co-Founder of the Pozitive Group. Pozitive Energy is the 8th largest gas & electricity provider in the UK having crossed over £2 billion in sales to SMEs. Neeraj is a seasoned entrepreneur having started and run a number of businesses in India, Singapore and the UK. The Pozitive Group has businesses in Payments, Insurance and the Fintech sectors."
  }
]

export default team
